import React from "react";
import { Paper, styled, Box, Typography} from "@mui/material";
import { Menu, Search, CloseOutlined} from "@mui/icons-material";

const DocPanel = styled(Paper)(({ theme }) => ({
    ["&"]: {
        flexGrow: '1',
        //height: 'calc(100% - 72px)',
        overflow: 'none',
        // marginRight: '-10px',
        // marginTop: '-8px',
        border: 'none'

    }
}));

const styles = {
    container: {
        backgroundColor: '#fff',
        height: '100%',
        display: "flex",
        flexDirection: "column",
        flexGrow: "1"
    },
    header: {
        color: '#e0e0e0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '42px',
        "& > *": {
            display: 'flex',
            alignItems: 'center',
            color: "#b5b2ba",
        }
    },
    headerLeft: {
        gap: '20px',
        width: '80px'
    },
    menu: {
        cursor: 'pointer',
        "&:hover": {
            color: "#333"
        }
    },
    headerMiddle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        fontSize: '14px !important',
    },
    headerRight: {
        width: '20px',
        paddingLeft: '60px',
        cursor: 'pointer',
        color: "#333",
        "&:hover": {
            color: "#333"
        }
    }
}

function HelpDocument(props){
    return (
        <Box sx={styles.container}>
            <Box sx={styles.header}>
                <div style={styles.headerLeft}>
                    {/* <Menu sx={styles.menu} onClick={() => props?.onHelpTree(!props?.helpTree)}/>
                    <Search sx={styles.menu}/> */}
                </div>
                <div style={styles.headerMiddle}>
                </div>
                <CloseOutlined sx={styles.headerRight} onClick={props?.onClose}/>
            </Box>
            <DocPanel variant="outlined">
            {/* <Highlighter
                activeClassName={styles.Active}
                activeIndex={activeIndex}
                caseSensitive={caseSensitive}
                highlightClassName={style.Highlight}
                highlightStyle={{ fontWeight: 'normal' }}
                // sanitize={latinize}
                searchWords={searchWords}
                textToHighlight={props.children}
                highlightTag={HighlightTag}
                />  */}
                {props.children}
            </DocPanel>
        </Box>
    )
}

export default React.memo(HelpDocument);